export const FETCH_SITES = "[ADMIN] FETCH_SITES";
export const FETCH_SITES_START = "[ADMIN] FETCH_SITES_START";
export const FETCH_SITES_SUCCESS = "[ADMIN] FETCH_SITES_SUCCESS";
export const FETCH_SITES_ERROR = "[ADMIN] FETCH_SITES_ERROR";



export const fetchSites = () => {
    return {
        type: FETCH_SITES,
    };
};

